import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import Line from '../../../packages/kiti/components/helpers/Line'
import Modal from '../../../components/structure/Modal'
import Scroll from '../../../packages/kiti/components/helpers/Scroll'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import SubmitBar from '../../../packages/kiti/components/form/SubmitBar'
import { Title } from '../../../packages/kiti/components/presentation/Text'
import WorkShiftsWeekDays from './WorkShiftsWeekDays'

const WorkShiftsModal = ({ validate, open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose} width="42rem" minHeight="40rem">
      <Grid justify="space-between">
        <Col flex={1}>
          <Title size="h5" noMargin>
            {'Configuração de turnos de trabalho'}
          </Title>
        </Col>
      </Grid>
      <Separator weight={2} />
      <Line />

      <Scroll height="55vh" scroll scrollX direction="row">
        <Separator weight={2} flex={1}>
          <WorkShiftsWeekDays path={['contract', 'workShifts']} />
        </Separator>
      </Scroll>
      <Line />

      <Separator paddingH={2}>
        <SubmitBar onClick={validate} />
      </Separator>
    </Modal>
  )
}

export default WorkShiftsModal
